import { observable, configure, action, computed } from 'mobx';
import LocalModel from './localModel';

import util from 'preact-util';
import { route } from 'preact-router';
import PubSub, { topics } from '../lib/pubsub';

configure({ enforceActions: 'always' });

class PollStore extends LocalModel {
    constructor() {
        super('poll', {
            namePlural: 'polls',
            namePluralReal: 'polls',
            sort: '-createdDate',
            limit: 100,
            api: {
                search: {
                    url: '/api/polls/',
                    params: {
                        limit: 100,
                    },
                },
                load: {
                    url: '/api/polls/',
                    params: {},
                },
                save: {
                    url: '/api/polls/',
                    params: {},
                },
                delete: {
                    url: '/api/polls/',
                    params: {},
                },
            },
        });
    }

    @observable newPoll = {};

    @observable poll = {};

    @observable polls = [];

    @action
    async votePoll(pollId, optionIndex) {
        const response = await util.fetchApi(`/api/polls/${pollId}/vote`, { method: 'POST' }, { optionIndex });
        return response;
    }

    @action
    async getPollResults(pollId) {
        const response = await util.fetchApi(`/api/polls/results/${pollId}`, { method: 'GET' });
        return response;
    }

    @action
    async createPoll({ type, objectId, question, options, expireDate }) {
        const response = await util.fetchApi('/api/polls/', { method: 'POST' }, {
            type,
            objectId,
            question,
            options,
            expireDate,
        });
        return response;
    }
}

const store = new PollStore();
export default store;

// Named export for the class itself
export { PollStore };
